export default {
  actionTypes: {
    loadSubordinates: 'WORKLOAD_LOAD_SUBORDINATES',
    selectSubordinate: 'WORKLOAD_SELECT_SUBORDINATE',
    loadSubordinateInfo: 'WORKLOAD_LOAD_SUBORDINATE_INFO',
    loadClients: 'WORKLOAD_LOAD_SUBORDINATES_CLIENTS',
    updateSubordinateSubscription: 'WORKLOAD_UPDATE_SUBORDINATE_SUBSCRIPTION',
    updateSideBarVisibility: 'WORKLOAD_UPDATE_SIDE_BAR_VISIBILITY',
  },
  mutationTypes: {
    setShowSideBar: 'WORKLOAD_SET_SHOW_SIDE_BAR',
    setSubordinates: 'WORKLOAD_SET_SUBORDINATES',
    setSubordinatesTotal: 'WORKLOAD_SET_SUBORDINATES_TOTAL',
    setSelectedSubordinateId: 'WORKLOAD_SET_SELECTED_SUBORDINATE_ID',
    setSubordinateInfo: 'WORKLOAD_SET_SUBORDINATE_INFO',
    setSubrodinatesLoading: 'WORKLOAD_SET_SUBORDINATES_LOADING',
    setSubrodinateInfoLoading: 'WORKLOAD_SET_SUBORDINATE_INFO_LOADING',
    setUpdatingSubordinateSubscription: 'WORKLOAD_SET_UPDATING_SUBORDINATE_SUBSCRIPTION',
    setSubordinatesClientsLoading: 'WORKLOAD_SET_SUBORDINATES_CLIENTS_LOADING',
    setSubordinatesClients: 'WORKLOAD_SET_SUBORDINATES_CLIENTS',
  },
  getterTypes: {
    selectedSubordinate: 'WORKLOAD_SELECTED_SUBORDINATE',
  },
};
